import { FC } from 'react';

const VectorIcon: FC = () => {
  return (
    <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M14.8109 13.9258L10.5072 9.61901C11.3557 8.60149 11.866 7.30115 11.866 5.88093C11.866 2.64084 9.20689 0.00634766 5.93606 0.00634766C2.66523 0.00634766 0 2.64391 0 5.884C0 9.12409 2.65908 11.7586 5.92991 11.7586C7.3194 11.7586 8.59822 11.2821 9.61267 10.4859L13.9318 14.805C14.1838 15.0571 14.5589 15.0571 14.8109 14.805C15.063 14.5529 15.063 14.1779 14.8109 13.9258ZM1.26038 5.884C1.26038 3.33866 3.3569 1.2698 5.92991 1.2698C8.50292 1.2698 10.5994 3.33866 10.5994 5.884C10.5994 8.42934 8.50292 10.4982 5.92991 10.4982C3.3569 10.4982 1.26038 8.42627 1.26038 5.884Z" fill="#BAA57E" />
    </svg>
  );
};

export default VectorIcon;